import React, { Component } from 'react';
import { SemVer, rcompare, parse } from "semver";
import { makeCdnUrl } from 'motion-master-client';

import { brandId } from "./brand";
import FirmwareBundlesContent from "./FirmwareBundlesContent";
import FirmwareChangelog from "./FirmwareChangelog";
import DownloadESI from "./DownloadESI";

class FirmwareList extends Component {
  constructor(props) {
    super(props);

    const allVersions = props.firmwares.sort(rcompare);

    this.state = {
      allVersions,
      filteredVersions: [],
      isFiltered: true,
    };

    this.filterLatestMinorVersions = this.filterLatestMinorVersions.bind(this);
  }

  componentDidMount() {
    this.setState({
      filteredVersions: this.filterLatestMinorVersions(),
    });
  }

  filterLatestMinorVersions() {
    const latestMinorVersionsMap = new Map();

    for (const item of this.state.allVersions) {
      const version = parse(item);
      const baseVersion = new SemVer(
        `${version.major}.${version.minor}.0`
      ).toString();

      if (!latestMinorVersionsMap.has(baseVersion)) {
        latestMinorVersionsMap.set(baseVersion, version);
      }

      const maxVersion = latestMinorVersionsMap.get(baseVersion);
      const cc = maxVersion.compare(version);
      if (cc < 0) {
        latestMinorVersionsMap.set(baseVersion, version);
      }
    }

    const latestMinorVersions = Array.from(latestMinorVersionsMap.values()).map(
      (v) => `v${v.toString()}`
    );

    // Filter all packages that contain the latest version
    return this.state.allVersions.filter((version) =>
      latestMinorVersions.includes(version)
    );
  }

  render() {
    return (
      <ul className="l-none list-inline">
        {(this.state.isFiltered
          ? this.state.filteredVersions
          : this.state.allVersions
        ).map((v) => {
          const link = makeCdnUrl(`/brands/${brandId}/bundles/firmwares/somanet-motion-drive_${encodeURIComponent(v)}.odbx`);
          const title = `Download firmware bundle ${v}`;
          return (
            <li className="list-inline-item mb-2" key={v}>
              <span className="btn-group rounded">
                <button
                  type="button"
                  className="btn btn-sm btn-outline-secondary px-2 dropdown-toggle dropdown-toggle-split"
                  data-toggle="dropdown"
                  aria-expanded="false"
                >
                  {v}&nbsp;
                </button>
                <div className="dropdown-menu shadow">
                  <h6 className="dropdown-header">Download</h6>
                  <a href={link} title={title} className="dropdown-item">
                    Firmware Bundle (.odbx)
                  </a>
                  <DownloadESI brandId={brandId} version={v} />
                  <div className="dropdown-divider"></div>
                  <h6 className="dropdown-header">Show</h6>
                  <FirmwareBundlesContent version={v} />
                  <FirmwareChangelog version={v} />
                </div>
              </span>
            </li>
          );
        })}
        <li className="list-inline-item mb-2">
          <button
            type="button"
            className="btn btn-link"
            onClick={() =>
              this.setState({ isFiltered: !this.state.isFiltered })
            }
          >
            {this.state.isFiltered
              ? "Show all versions"
              : "Hide old patch versions"}
          </button>
        </li>
      </ul>
    );
  }
}

export default FirmwareList;
